import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IReleaseEntry, ILangItem } from "@common/types/sharedTypes";
import { SXModalBase } from "./SXModal";

// ILangItem has no `fi`, but the notes carry one, so look the language up by name.
const noteText = (note: ILangItem, lang: string) =>
  (note as unknown as Record<string, string | undefined>)[lang] ?? note.en;

// The notes are plain text with `**bold**` runs and `\n` line breaks.
const ReleaseNoteText = ({ text }: { text: string }) => (
  <span style={{ whiteSpace: "pre-line" }}>
    {text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => {
      const boldText = /^\*\*(.+)\*\*$/.exec(part)?.[1];
      return boldText ? <strong key={index}>{boldText}</strong> : <span key={index}>{part}</span>;
    })}
  </span>
);

interface ReleaseNotesModalProps {
  show: boolean;
  close: () => void;
  header: string;
  releases: IReleaseEntry[];
}

export const ReleaseNotesModal = ({ show, close, header, releases }: ReleaseNotesModalProps) => {
  const { t, i18n } = useTranslation();

  return (
    <SXModalBase
      header={header}
      show={show}
      size="lg"
      close={close}
      body={
        <div>
          {releases.map((release) => (
            <div key={release.version} className="mb-3">
              <strong>
                {release.version} ({release.date})
              </strong>
              <ul>
                {release.notes.map((note, index) => (
                  <li key={index}>
                    <ReleaseNoteText text={noteText(note, i18n.language)} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      }
      footer={
        <Button id="releaseNotesOk" className="modal-btn" onClick={close}>
          {t("general.ok")}
        </Button>
      }
    />
  );
};
